import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Composant qui scroll automatiquement vers le haut à chaque changement de page
 * Utilise un scroll fluide pour une meilleure expérience utilisateur
 */
const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Scroll immédiat vers le haut
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // Scroll instantané pour un changement de page
    });

    // Backup: forcer le scroll après un court délai pour s'assurer que ça fonctionne
    const timeoutId = setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant'
      });
    }, 50);

    // Nettoyer le timeout
    return () => clearTimeout(timeoutId);
  }, [pathname, search]); // Se déclenche à chaque changement de route ou de paramètres

  return null;
};

export default ScrollToTop;
